document.addEventListener('DOMContentLoaded', function() {
    // Проверяем, не согласился ли уже пользователь
    if (!localStorage.getItem('cookiesAccepted')) {
        const modal = document.getElementById('cookieModal');
        const acceptBtn = document.getElementById('acceptCookies');

        modal.style.display = 'block';

        acceptBtn.addEventListener('click', function() {
            // Сохраняем согласие на 1 год
            const expiryDate = new Date();
            expiryDate.setFullYear(expiryDate.getFullYear() + 1);

            localStorage.setItem('cookiesAccepted', 'true');
            localStorage.setItem('cookiesAcceptDate', expiryDate.toISOString());

            modal.style.display = 'none';
        });
    }
});